var styles = {"article":"HeaderWindow-module_article__RS2aU","padding-wide":"HeaderWindow-module_padding-wide__2Eah5"};

export { styles as default };
